export const SKIP_WHEN_LOGGED_IN: string[] = [
  "/checkout/hosting/starter/create-account",
];

// 2.18.0 commit. Use sp.js, not sp.min.js: jsDelivr generates the latter and SRI would fail.
export const SNOWPLOW_SCRIPT_SRC =
  "https://cdn.jsdelivr.net/gh/snowplow/sp-js-assets@8cd1add23a495b37da67efa8ae32ff02f132e358/sp.js";

export const SNOWPLOW_SCRIPT_INTEGRITY =
  "sha384-rlxKPllmNo7WPWtA9feAKuHrSf8+mPSp8rXeRLOz+B1LXpf/8IWR4eRamlaM4Qm5";
